<template>
  <div class="container">
    Up
  </div>
</template>

<script>
</script>

<style>
.dotted-underline-info {
  border-bottom: 2px black dotted;
}
</style>
